(() => {
  if (window.__OSTUKLIKK_WISHLIST_FAST__) {
    return;
  }

  window.__OSTUKLIKK_WISHLIST_FAST__ = true;


  /* =========================================================
     SETTINGS
     ========================================================= */

  const STORAGE_KEY =
    'wishlist_v1';

  const CACHE_VERSION =
    'v8';

  const CACHE_TTL =
    10 * 60 * 1000;

  const MAX_CONCURRENT =
    12;

  let renderToken =
    0;

  let languageUpdateTimer =
    null;

  const inFlightRequests =
    new Map();


  /* =========================================================
     LANGUAGES
     ========================================================= */

  const translations = {
    en: {
      priceWithVat:
        'Price with VAT',

      priceWithoutVat:
        'Price without VAT',

      localStock:
        'Local stock',

      euStock:
        'EU stock',

      unit:
        'pcs',

      addToCart:
        'Add to cart',

      removeFavorite:
        'Remove from favorites',

      addFavorite:
        'Add to favorites',

      unavailable:
        'Unavailable',

      unavailableProduct:
        'This product is no longer available.',

      adding:
        'Adding...',

      added:
        'Added ✓',

      tryAgain:
        'Try again'
    },


    et: {
      priceWithVat:
        'Hind km-ga',

      priceWithoutVat:
        'Hind km-ita',

      localStock:
        'Kohalikus laos',

      euStock:
        'EL-i laos',

      unit:
        'tk',

      addToCart:
        'Lisa ostukorvi',

      removeFavorite:
        'Eemalda lemmikutest',

      addFavorite:
        'Lisa lemmikutesse',

      unavailable:
        'Pole saadaval',

      unavailableProduct:
        'Seda toodet ei ole enam saadaval.',

      adding:
        'Lisan...',

      added:
        'Lisatud ✓',

      tryAgain:
        'Proovi uuesti'
    },


    fi: {
      priceWithVat:
        'Hinta sis. ALV',

      priceWithoutVat:
        'Hinta ilman ALV:tä',

      localStock:
        'Paikallinen varasto',

      euStock:
        'EU-varasto',

      unit:
        'kpl',

      addToCart:
        'Lisää ostoskoriin',

      removeFavorite:
        'Poista suosikeista',

      addFavorite:
        'Lisää suosikkeihin',

      unavailable:
        'Ei saatavilla',

      unavailableProduct:
        'Tätä tuotetta ei ole enää saatavilla.',

      adding:
        'Lisätään...',

      added:
        'Lisätty ✓',

      tryAgain:
        'Yritä uudelleen'
    },


    ru: {
      priceWithVat:
        'Цена с НДС',

      priceWithoutVat:
        'Цена без НДС',

      localStock:
        'Местный склад',

      euStock:
        'Склад ЕС',

      unit:
        'шт.',

      addToCart:
        'Добавить в корзину',

      removeFavorite:
        'Удалить из избранного',

      addFavorite:
        'Добавить в избранное',

      unavailable:
        'Нет в наличии',

      unavailableProduct:
        'Этот товар больше недоступен.',

      adding:
        'Добавление...',

      added:
        'Добавлено ✓',

      tryAgain:
        'Попробовать снова'
    }
  };


  /* =========================================================
     LANGUAGE NORMALIZATION
     ========================================================= */

  function normalizeLanguage(
    value
  ) {
    if (!value) {
      return null;
    }


    const normalized =
      String(value)
        .trim()
        .toLowerCase()
        .replace('_', '-');


    if (
      normalized === 'et' ||
      normalized.startsWith('et-') ||
      normalized === 'eesti' ||
      normalized === 'estonian'
    ) {
      return 'et';
    }


    if (
      normalized === 'fi' ||
      normalized.startsWith('fi-') ||
      normalized === 'suomi' ||
      normalized === 'finnish'
    ) {
      return 'fi';
    }


    if (
      normalized === 'ru' ||
      normalized.startsWith('ru-') ||
      normalized === 'русский' ||
      normalized === 'russian'
    ) {
      return 'ru';
    }


    if (
      normalized === 'en' ||
      normalized.startsWith('en-') ||
      normalized === 'english'
    ) {
      return 'en';
    }


    return null;
  }


  /* =========================================================
     VISIBILITY
     ========================================================= */

  function isVisible(
    element
  ) {
    if (!element) {
      return false;
    }


    return Boolean(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  }


  /* =========================================================
     CURRENT LANGUAGE
     ========================================================= */

  function getLanguage() {

    /*
     * Shopify localization select
     */
    const localeSelect =
      document.querySelector(
        'select[name="locale_code"]'
      );


    if (localeSelect) {

      const language =
        normalizeLanguage(
          localeSelect.value
        );


      if (language) {
        return language;
      }
    }


    /*
     * Localization radio/input
     */
    const checkedLocale =
      document.querySelector(
        'input[name="locale_code"]:checked'
      );


    if (checkedLocale) {

      const language =
        normalizeLanguage(
          checkedLocale.value
        );


      if (language) {
        return language;
      }
    }


    /*
     * Headeris nähtav keelevalik.
     */
    const visibleCandidates =
      Array.from(
        document.querySelectorAll(
          [
            '#header-group button',
            '#header-group summary',
            '#header-group [role="button"]',
            'localization-form button',
            '.localization-form button'
          ].join(',')
        )
      );


    for (
      const element
      of visibleCandidates
    ) {

      if (!isVisible(element)) {
        continue;
      }


      const language =
        normalizeLanguage(
          element.textContent?.trim()
        );


      if (language) {
        return language;
      }
    }


    /*
     * HTML lang
     */
    const htmlLanguage =
      normalizeLanguage(
        document.documentElement.lang
      );


    if (htmlLanguage) {
      return htmlLanguage;
    }


    /*
     * Shopify.locale
     */
    const shopifyLanguage =
      normalizeLanguage(
        window.Shopify?.locale
      );


    if (shopifyLanguage) {
      return shopifyLanguage;
    }


    /*
     * URL prefix
     */
    const pathParts =
      window.location.pathname
        .split('/')
        .filter(Boolean);


    const pathLanguage =
      normalizeLanguage(
        pathParts[0]
      );


    if (pathLanguage) {
      return pathLanguage;
    }


    return 'en';
  }


  /* =========================================================
     TRANSLATION
     ========================================================= */

  function t(
    key
  ) {
    const language =
      getLanguage();


    const dictionary =
      translations[language] ||
      translations.en;


    return (
      dictionary[key] ||
      translations.en[key] ||
      key
    );
  }


  /* =========================================================
     LOCALIZED STOREFRONT ROOT
     ========================================================= */

  function getLocalizedRoot() {
    const language =
      getLanguage();


    const alternateLinks =
      Array.from(
        document.querySelectorAll(
          'link[rel="alternate"][hreflang][href]'
        )
      );


    const alternate =
      alternateLinks.find(
        link => {
          return (
            normalizeLanguage(
              link.getAttribute(
                'hreflang'
              )
            ) === language
          );
        }
      );


    if (alternate) {

      try {

        const url =
          new URL(
            alternate.href,
            window.location.origin
          );


        const pathname =
          url.pathname;


        const knownParts = [
          '/pages/',
          '/collections/',
          '/products/',
          '/blogs/',
          '/search'
        ];


        for (
          const marker
          of knownParts
        ) {

          const index =
            pathname.indexOf(
              marker
            );


          if (index >= 0) {

            let root =
              pathname.slice(
                0,
                index + 1
              );


            if (!root) {
              root = '/';
            }


            if (
              !root.endsWith('/')
            ) {
              root += '/';
            }


            return root;
          }
        }

      } catch (error) {
        /* fallback below */
      }
    }


    return (
      window.Shopify
        ?.routes
        ?.root ||
      '/'
    );
  }


  /* =========================================================
     CACHE PREFIX
     ========================================================= */

  function getCachePrefix() {
    return (
      `ostuklikk_wishlist_card_${CACHE_VERSION}:` +
      `${getLanguage()}:`
    );
  }


  /* =========================================================
     STORAGE
     ========================================================= */

  function getWishlist() {
    try {

      const parsed =
        JSON.parse(
          localStorage.getItem(
            STORAGE_KEY
          )
        );


      if (!Array.isArray(parsed)) {
        return [];
      }


      return [
        ...new Set(
          parsed.filter(Boolean)
        )
      ];

    } catch (error) {

      return [];
    }
  }


  function writeWishlist(
    items
  ) {
    const uniqueItems = [
      ...new Set(
        items.filter(Boolean)
      )
    ].slice(
      0,
      100
    );


    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(
        uniqueItems
      )
    );


    return uniqueItems;
  }


  function dispatchWishlistChange(
    items,
    action = null,
    handle = null
  ) {
    document.dispatchEvent(
      new CustomEvent(
        'wishlist:change',
        {
          detail: {
            items,
            action,
            handle
          }
        }
      )
    );
  }


  function hasProduct(
    handle
  ) {
    if (!handle) {
      return false;
    }


    return getWishlist()
      .includes(
        handle
      );
  }


  function addProduct(
    handle
  ) {
    if (!handle) {
      return;
    }


    const items =
      getWishlist();


    if (
      items.includes(handle)
    ) {
      return;
    }


    items.unshift(
      handle
    );


    const savedItems =
      writeWishlist(
        items
      );


    dispatchWishlistChange(
      savedItems,
      'add',
      handle
    );
  }


  function removeProduct(
    handle
  ) {
    if (!handle) {
      return false;
    }


    const currentItems =
      getWishlist();


    const updatedItems =
      currentItems.filter(
        item =>
          item !== handle
      );


    if (
      updatedItems.length ===
      currentItems.length
    ) {
      return false;
    }


    const savedItems =
      writeWishlist(
        updatedItems
      );


    if (
      savedItems.includes(
        handle
      ) ||
      getWishlist().includes(
        handle
      )
    ) {

      console.warn(
        'Wishlist item could not be removed:',
        handle
      );


      return false;
    }


    dispatchWishlistChange(
      savedItems,
      'remove',
      handle
    );


    return true;
  }


  function toggleProduct(
    handle
  ) {
    if (!handle) {
      return false;
    }


    if (
      hasProduct(handle)
    ) {

      removeProduct(
        handle
      );


      return false;
    }


    addProduct(
      handle
    );


    return true;
  }


  /* =========================================================
     PRODUCT PAGE WISHLIST LAYER FIX
     ========================================================= */

  let productWishlistOverlapFrame =
    null;


  function getProductWishlistButtons() {

    return Array.from(
      document.querySelectorAll(
        '.wishlist-button--product[data-wishlist-button]'
      )
    );
  }


  function getMobileHeaderBottom() {

    if (
      window.matchMedia(
        '(min-width: 750px)'
      ).matches
    ) {
      return 0;
    }


    const candidates =
      Array.from(
        document.querySelectorAll(
          [
            '#header-group .header-section',
            '#header-group .ostuklik-header-search',
            '.ostuklik-header-search'
          ].join(',')
        )
      );


    let bottom =
      0;


    candidates.forEach(
      element => {

        if (!isVisible(element)) {
          return;
        }


        const rect =
          element.getBoundingClientRect();


        if (
          rect.bottom <= 0 ||
          rect.top >= window.innerHeight
        ) {
          return;
        }


        const styles =
          window.getComputedStyle(
            element
          );


        const stickyLike =
          styles.position === 'sticky' ||
          styles.position === 'fixed' ||
          element.classList.contains(
            'header-section'
          ) ||
          element.classList.contains(
            'ostuklik-header-search'
          );


        if (!stickyLike) {
          return;
        }


        bottom =
          Math.max(
            bottom,
            rect.bottom
          );
      }
    );


    return Math.max(
      0,
      bottom
    );
  }


  function updateProductWishlistHeaderOverlap() {

    const buttons =
      getProductWishlistButtons();


    if (!buttons.length) {
      return;
    }


    const isMobile =
      window.matchMedia(
        '(max-width: 749px)'
      ).matches;


    const headerBottom =
      isMobile
        ? getMobileHeaderBottom()
        : 0;


    buttons.forEach(
      button => {

        if (!isMobile) {

          button.style.removeProperty(
            'opacity'
          );


          button.style.removeProperty(
            'visibility'
          );


          button.style.removeProperty(
            'pointer-events'
          );


          return;
        }


        const rect =
          button.getBoundingClientRect();


        const overlapsHeader =
          headerBottom > 0 &&
          rect.top < headerBottom &&
          rect.bottom > 0;


        if (overlapsHeader) {

          /*
           * Kui nupp jõuab mobiili sticky päise / otsingu
           * alla, peidame ta täpselt selleks ajaks.
           * Visuaalselt käitub nupp nii, nagu läheks ta
           * päriselt päise taha.
           */
          button.style.setProperty(
            'opacity',
            '0',
            'important'
          );


          button.style.setProperty(
            'visibility',
            'hidden',
            'important'
          );


          button.style.setProperty(
            'pointer-events',
            'none',
            'important'
          );

        } else {

          button.style.removeProperty(
            'opacity'
          );


          button.style.removeProperty(
            'visibility'
          );


          button.style.removeProperty(
            'pointer-events'
          );
        }
      }
    );
  }


  function scheduleProductWishlistHeaderOverlap() {

    if (productWishlistOverlapFrame) {
      return;
    }


    productWishlistOverlapFrame =
      window.requestAnimationFrame(
        () => {

          productWishlistOverlapFrame =
            null;


          updateProductWishlistHeaderOverlap();
        }
      );
  }


  function fixProductPageWishlistLayer() {

    const buttons =
      getProductWishlistButtons();


    if (!buttons.length) {
      return;
    }


    buttons.forEach(
      button => {

        /*
         * wishlist.css annab üldisele wishlist-button klassile
         * z-index: 30. Tootelehel ei ole seda vaja.
         */
        button.style.setProperty(
          'position',
          'relative',
          'important'
        );


        button.style.setProperty(
          'z-index',
          '0',
          'important'
        );


        /*
         * Kui Horizon on tooteinfo sticky-content konteinerisse
         * pannud, langetame ka selle konteineri taseme nulli.
         */
        let parent =
          button.parentElement;


        while (
          parent &&
          parent !== document.body &&
          parent.id !== 'MainContent'
        ) {

          const styles =
            window.getComputedStyle(
              parent
            );


          const isStickyParent =
            styles.position === 'sticky' ||
            parent.classList.contains(
              'sticky-content'
            ) ||
            parent.classList.contains(
              'sticky-content--desktop'
            );


          if (isStickyParent) {

            parent.style.setProperty(
              'z-index',
              '0',
              'important'
            );
          }


          parent =
            parent.parentElement;
        }
      }
    );


    updateProductWishlistHeaderOverlap();
  }


  function initProductWishlistLayerFix() {

    /*
     * PERFORMANCE:
     * Seda scroll/resize loogikat on vaja ainult päris tootelehel,
     * kus eksisteerib suur .wishlist-button--product nupp.
     * Cart, collection, search, homepage ja wishlist ei lisa enam
     * täiesti tarbetuid scroll/resize listenereid.
     */
    const buttons =
      getProductWishlistButtons();


    if (!buttons.length) {
      return;
    }


    if (
      window.__OSTUKLIKK_WISHLIST_LAYER_FIX__
    ) {

      fixProductPageWishlistLayer();

      return;
    }


    window.__OSTUKLIKK_WISHLIST_LAYER_FIX__ =
      true;


    window.addEventListener(
      'scroll',
      scheduleProductWishlistHeaderOverlap,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'resize',
      scheduleProductWishlistHeaderOverlap,
      {
        passive:
          true
      }
    );


    fixProductPageWishlistLayer();
  }


  /* =========================================================
     UPDATE HEARTS + COUNT
     ========================================================= */

  function updateButtons() {
    const items =
      getWishlist();


    document
      .querySelectorAll(
        '[data-wishlist-button]'
      )
      .forEach(
        button => {

          const handle =
            button.dataset
              .productHandle;


          if (!handle) {
            return;
          }


          const active =
            items.includes(
              handle
            );


          button.classList.toggle(
            'wishlist-button--active',
            active
          );


          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );


          button.setAttribute(
            'aria-label',
            active
              ? t(
                  'removeFavorite'
                )
              : t(
                  'addFavorite'
                )
          );
        }
      );


    const count =
      items.length;


    document
      .querySelectorAll(
        '[data-wishlist-count]'
      )
      .forEach(
        element => {

          const nextText =
            String(count);


          const shouldHide =
            count === 0;


          /*
           * PERFORMANCE:
           * Ära kirjuta headeri DOM-i uuesti, kui väärtus pole muutunud.
           * See hoiab ära tarbetud layout/repaint tsüklid mobiilis.
           */
          if (
            element.textContent !==
            nextText
          ) {

            element.textContent =
              nextText;
          }


          if (
            element.hidden !==
            shouldHide
          ) {

            element.hidden =
              shouldHide;
          }
        }
      );


    fixProductPageWishlistLayer();
  }


  /* =========================================================
     CACHE
     ========================================================= */

  function getCachedCard(
    handle
  ) {
    try {

      const raw =
        sessionStorage.getItem(
          getCachePrefix() +
          handle
        );


      if (!raw) {
        return null;
      }


      const cached =
        JSON.parse(
          raw
        );


      if (
        !cached ||
        !cached.html ||
        !cached.time
      ) {
        return null;
      }


      if (
        Date.now() -
        cached.time >
        CACHE_TTL
      ) {

        sessionStorage.removeItem(
          getCachePrefix() +
          handle
        );


        return null;
      }


      return cached.html;

    } catch (error) {

      return null;
    }
  }


  function setCachedCard(
    handle,
    html
  ) {
    try {

      sessionStorage.setItem(
        getCachePrefix() +
        handle,

        JSON.stringify({
          time:
            Date.now(),

          html
        })
      );

    } catch (error) {

      /* Cache optional */
    }
  }


  function clearCachedCard(
    handle
  ) {
    try {

      const languages = [
        'en',
        'et',
        'fi',
        'ru'
      ];


      languages.forEach(
        language => {

          sessionStorage.removeItem(
            `ostuklikk_wishlist_card_${CACHE_VERSION}:${language}:${handle}`
          );
        }
      );

    } catch (error) {

      /* ignore */
    }
  }


  /* =========================================================
     REMOVE HEART FROM WISHLIST CARD
     ========================================================= */

  function removeCardHeart(
    productCard
  ) {
    if (!productCard) {
      return;
    }


    const selectors = [
      '.wishlist-button',
      '[data-wishlist-button]',
      '[data-wishlist-toggle]',
      '[data-favorite-toggle]',
      '[data-favourite-toggle]'
    ];


    selectors.forEach(
      selector => {

        productCard
          .querySelectorAll(
            selector
          )
          .forEach(
            element => {

              element.remove();
            }
          );
      }
    );
  }


  /* =========================================================
     DISABLE FULL CARD OVERLAY
     ========================================================= */

  function disableCardOverlay(
    productCard
  ) {
    if (!productCard) {
      return;
    }


    const overlayLink =
      productCard.querySelector(
        ':scope > .product-card__link'
      );


    if (overlayLink) {

      overlayLink.style.pointerEvents =
        'none';


      overlayLink.style.zIndex =
        '0';
    }


    const content =
      productCard.querySelector(
        '.product-card__content'
      );


    if (content) {

      content.style.position =
        'relative';


      content.style.zIndex =
        '2';
    }
  }


  /* =========================================================
     MOVE ACTIONS INTO LOWER BOX
     ========================================================= */

  function moveActionsIntoCard(
    card
  ) {
    const actions =
      card.querySelector(
        '[data-wishlist-actions]'
      );


    const priceBlock =
      card.querySelector(
        'product-price'
      );


    if (
      !actions ||
      !priceBlock
    ) {
      return;
    }


    if (
      actions.parentElement !==
      priceBlock
    ) {

      priceBlock.appendChild(
        actions
      );
    }


    actions.style.position =
      'relative';


    actions.style.zIndex =
      '100';


    actions.style.pointerEvents =
      'auto';
  }


  /* =========================================================
     SAVE REAL AVAILABILITY STATE

     See on oluline.

     Shopify disabled button tähendab alguses:
     "toode päriselt pole saadaval".

     Meie enda ajutine disabled ostukorvi lisamisel
     EI TOHI hiljem muutuda tekstiks "Unavailable".
     ========================================================= */

  function initializeCartButtonState(
    root
  ) {
    if (!root) {
      return;
    }


    root
      .querySelectorAll(
        '[data-wishlist-add-to-cart]'
      )
      .forEach(
        button => {

          /*
           * Salvestame saadavuse ainult üks kord,
           * enne kui meie JS ise disabled olekut muudab.
           */
          if (
            button.dataset
              .wishlistUnavailable ===
            undefined
          ) {

            button.dataset
              .wishlistUnavailable =
              button.disabled
                ? 'true'
                : 'false';
          }


          if (
            button.dataset
              .wishlistBusy ===
            undefined
          ) {

            button.dataset
              .wishlistBusy =
              'false';
          }
        }
      );
  }


  /* =========================================================
     TEXT REPLACEMENT
     ========================================================= */

  function replaceTextInside(
    root,
    replacements
  ) {
    if (!root) {
      return;
    }


    const walker =
      document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );


    const nodes =
      [];


    while (
      walker.nextNode()
    ) {

      nodes.push(
        walker.currentNode
      );
    }


    nodes.forEach(
      node => {

        let value =
          node.nodeValue;


        if (!value) {
          return;
        }


        replacements.forEach(
          replacement => {

            value =
              value.replace(
                replacement.pattern,
                replacement.value
              );
          }
        );


        node.nodeValue =
          value;
      }
    );
  }


  /* =========================================================
     TRANSLATE DYNAMIC PRODUCT CARD
     ========================================================= */

  function translateCard(
    card
  ) {
    if (!card) {
      return;
    }


    const language =
      getLanguage();


    const dictionary =
      translations[language] ||
      translations.en;


    /*
     * Hinnasildid
     */
    card
      .querySelectorAll(
        '.ostuklik-price--gross .ostuklik-price__label'
      )
      .forEach(
        label => {

          label.textContent =
            `${dictionary.priceWithVat}:`;
        }
      );


    card
      .querySelectorAll(
        '.ostuklik-price--net .ostuklik-price__label'
      )
      .forEach(
        label => {

          label.textContent =
            `${dictionary.priceWithoutVat}:`;
        }
      );


    /*
     * Ostukorvi nupud
     */
    card
      .querySelectorAll(
        '[data-wishlist-add-to-cart]'
      )
      .forEach(
        button => {

          /*
           * Kui nupp on parajasti olekus
           * Adding... või Added ✓,
           * ei kirjuta tõlge seda üle.
           */
          const busy =
            button.dataset
              .wishlistBusy ===
            'true';


          if (busy) {
            return;
          }


          const unavailable =
            button.dataset
              .wishlistUnavailable ===
            'true';


          if (unavailable) {

            button.disabled =
              true;


            button.textContent =
              dictionary.unavailable;

          } else {

            button.disabled =
              false;


            button.textContent =
              dictionary.addToCart;
          }
        }
      );


    /*
     * Eemalda lemmikutest
     */
    card
      .querySelectorAll(
        '[data-wishlist-remove]'
      )
      .forEach(
        button => {

          button.textContent =
            dictionary.removeFavorite;
        }
      );


    /*
     * Laoseis
     */
    const priceArea =
      card.querySelector(
        'product-price'
      );


    if (priceArea) {

      replaceTextInside(
        priceArea,
        [
          {
            pattern:
              /(?:Local stock|Kohalikus laos|Paikallinen varasto|Местный склад)\s*:/gi,

            value:
              `${dictionary.localStock}:`
          },

          {
            pattern:
              /(?:EU stock|EL-i laos|EU-varasto|Склад ЕС)\s*:/gi,

            value:
              `${dictionary.euStock}:`
          },

          {
            pattern:
              /(\d+)\s*(?:pcs|tk|kpl|шт\.?)(?=\s|$)/gi,

            value:
              `$1 ${dictionary.unit}`
          }
        ]
      );
    }
  }


  /* =========================================================
     TRANSLATE ALL CARDS
     ========================================================= */

  function translateAllCards() {

    document
      .querySelectorAll(
        '[data-wishlist-card-fragment]'
      )
      .forEach(
        card => {

          translateCard(
            card
          );
        }
      );


    document
      .querySelectorAll(
        '.wishlist-unavailable-card'
      )
      .forEach(
        card => {

          const text =
            card.querySelector(
              'p'
            );


          if (text) {

            text.textContent =
              t(
                'unavailableProduct'
              );
          }


          const remove =
            card.querySelector(
              '[data-wishlist-remove]'
            );


          if (remove) {

            remove.textContent =
              t(
                'removeFavorite'
              );
          }
        }
      );
  }


  /* =========================================================
     BUILD CARD
     ========================================================= */

  function buildCard(
    originalHandle,
    html
  ) {
    const parsed =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const source =
      parsed.querySelector(
        '[data-wishlist-card-fragment]'
      );


    if (!source) {

      throw new Error(
        `Wishlist fragment missing: ${originalHandle}`
      );
    }


    const sourceProductCard =
      source.querySelector(
        'product-card'
      );


    if (!sourceProductCard) {

      throw new Error(
        `Product card missing: ${originalHandle}`
      );
    }


    const wrapper =
      document.createElement(
        'div'
      );


    wrapper.className =
      'wishlist-card-fragment resource-list__item';


    wrapper.setAttribute(
      'data-wishlist-card-fragment',
      ''
    );


    wrapper.dataset.productHandle =
      originalHandle;


    wrapper.dataset
      .wishlistStorageHandle =
      originalHandle;


    const productCard =
      document.importNode(
        sourceProductCard,
        true
      );


    removeCardHeart(
      productCard
    );


    disableCardOverlay(
      productCard
    );


    wrapper.appendChild(
      productCard
    );


    const sourceActions =
      source.querySelector(
        '[data-wishlist-actions]'
      );


    if (sourceActions) {

      const actions =
        document.importNode(
          sourceActions,
          true
        );


      actions.dataset.productHandle =
        originalHandle;


      actions.dataset
        .wishlistStorageHandle =
        originalHandle;


      actions
        .querySelectorAll(
          '[data-wishlist-remove]'
        )
        .forEach(
          removeButton => {

            removeButton.dataset
              .productHandle =
              originalHandle;


            removeButton.dataset
              .wishlistRemove =
              originalHandle;


            removeButton.dataset
              .wishlistStorageHandle =
              originalHandle;
          }
        );


      wrapper.appendChild(
        actions
      );
    }


    moveActionsIntoCard(
      wrapper
    );


    /*
     * Salvestame päris saadavuse
     * enne tõlkimist.
     */
    initializeCartButtonState(
      wrapper
    );


    translateCard(
      wrapper
    );


    return wrapper;
  }


  /* =========================================================
     FETCH
     ========================================================= */

  async function fetchCardHTML(
    handle
  ) {
    const cached =
      getCachedCard(
        handle
      );


    if (cached) {
      return cached;
    }


    if (
      inFlightRequests.has(
        handle
      )
    ) {

      return inFlightRequests
        .get(handle)
        .promise;
    }


    const controller =
      new AbortController();


    const localizedRoot =
      getLocalizedRoot();


    const url =
      `${localizedRoot}products/${encodeURIComponent(handle)}?view=wishlist-card`;


    const promise =
      fetch(
        url,
        {
          credentials:
            'same-origin',

          signal:
            controller.signal,

          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        }
      )

        .then(
          response => {

            if (!response.ok) {

              throw new Error(
                `Product loading failed: ${handle}`
              );
            }


            return response.text();
          }
        )

        .then(
          html => {

            setCachedCard(
              handle,
              html
            );


            return html;
          }
        )

        .finally(
          () => {

            inFlightRequests.delete(
              handle
            );
          }
        );


    inFlightRequests.set(
      handle,
      {
        controller,
        promise
      }
    );


    return promise;
  }


  function cancelCardFetch(
    handle
  ) {
    const request =
      inFlightRequests.get(
        handle
      );


    if (!request) {
      return;
    }


    request.controller.abort();


    inFlightRequests.delete(
      handle
    );
  }


  /* =========================================================
     PLACEHOLDER
     ========================================================= */

  function createPlaceholder(
    handle
  ) {
    const placeholder =
      document.createElement(
        'div'
      );


    placeholder.className =
      'wishlist-card-loading resource-list__item';


    placeholder.dataset.productHandle =
      handle;


    placeholder.dataset
      .wishlistStorageHandle =
      handle;


    placeholder.setAttribute(
      'aria-hidden',
      'true'
    );


    return placeholder;
  }


  /* =========================================================
     UNAVAILABLE CARD
     ========================================================= */

  function createUnavailableCard(
    handle
  ) {
    const card =
      document.createElement(
        'div'
      );


    card.className =
      'wishlist-unavailable-card';


    card.dataset.productHandle =
      handle;


    card.dataset
      .wishlistStorageHandle =
      handle;


    const text =
      document.createElement(
        'p'
      );


    text.textContent =
      t(
        'unavailableProduct'
      );


    const button =
      document.createElement(
        'button'
      );


    button.type =
      'button';


    button.className =
      'wishlist-remove-link';


    button.dataset
      .wishlistRemove =
      handle;


    button.dataset
      .productHandle =
      handle;


    button.dataset
      .wishlistStorageHandle =
      handle;


    button.textContent =
      t(
        'removeFavorite'
      );


    card.appendChild(
      text
    );


    card.appendChild(
      button
    );


    return card;
  }


  /* =========================================================
     EMPTY STATE
     ========================================================= */

  function updateEmptyState() {
    const page =
      document.querySelector(
        '[data-wishlist-page]'
      );


    if (!page) {
      return;
    }


    const grid =
      page.querySelector(
        '[data-wishlist-grid]'
      );


    const empty =
      page.querySelector(
        '[data-wishlist-empty]'
      );


    if (!grid) {
      return;
    }


    const remaining =
      grid.querySelectorAll(
        [
          '[data-wishlist-card-fragment]',
          '.wishlist-card-loading',
          '.wishlist-unavailable-card'
        ].join(',')
      );


    const hasItems =
      remaining.length > 0;


    grid.hidden =
      !hasItems;


    if (empty) {

      empty.hidden =
        hasItems;
    }
  }


  /* =========================================================
     REMOVE FROM PAGE
     ========================================================= */

  function removeCardFromPage(
    handle
  ) {
    if (!handle) {
      return;
    }


    document
      .querySelectorAll(
        [
          '[data-wishlist-card-fragment]',
          '.wishlist-card-loading',
          '.wishlist-unavailable-card'
        ].join(',')
      )
      .forEach(
        card => {

          const cardHandle =
            card.dataset
              .wishlistStorageHandle ||

            card.dataset
              .productHandle;


          if (
            cardHandle ===
            handle
          ) {

            card.remove();
          }
        }
      );


    cancelCardFetch(
      handle
    );


    clearCachedCard(
      handle
    );


    updateEmptyState();
  }


  /* =========================================================
     LOAD WISHLIST
     ========================================================= */

  async function loadWishlistPage() {
    const page =
      document.querySelector(
        '[data-wishlist-page]'
      );


    if (!page) {
      return;
    }


    const grid =
      page.querySelector(
        '[data-wishlist-grid]'
      );


    const empty =
      page.querySelector(
        '[data-wishlist-empty]'
      );


    const loading =
      page.querySelector(
        '[data-wishlist-loading]'
      );


    if (!grid) {
      return;
    }


    const handles =
      getWishlist();


    const currentRender =
      ++renderToken;


    inFlightRequests.forEach(
      request => {

        request.controller.abort();
      }
    );


    inFlightRequests.clear();


    if (!handles.length) {

      grid.replaceChildren();


      grid.hidden =
        true;


      if (loading) {

        loading.hidden =
          true;
      }


      if (empty) {

        empty.hidden =
          false;
      }


      return;
    }


    if (empty) {

      empty.hidden =
        true;
    }


    if (loading) {

      loading.hidden =
        false;
    }


    const placeholders =
      handles.map(
        handle =>
          createPlaceholder(
            handle
          )
      );


    grid.replaceChildren(
      ...placeholders
    );


    grid.hidden =
      false;


    let nextIndex =
      0;


    let firstCardShown =
      false;


    async function worker() {

      while (
        nextIndex <
        handles.length
      ) {

        const index =
          nextIndex++;


        const originalHandle =
          handles[index];


        const placeholder =
          placeholders[index];


        try {

          const html =
            await fetchCardHTML(
              originalHandle
            );


          if (
            currentRender !==
            renderToken
          ) {
            return;
          }


          if (
            !hasProduct(
              originalHandle
            )
          ) {

            placeholder.remove();

            continue;
          }


          const card =
            buildCard(
              originalHandle,
              html
            );


          if (
            placeholder.isConnected
          ) {

            placeholder.replaceWith(
              card
            );
          }


          if (
            !firstCardShown
          ) {

            firstCardShown =
              true;


            if (loading) {

              loading.hidden =
                true;
            }
          }

        } catch (error) {

          if (
            error.name ===
            'AbortError'
          ) {
            continue;
          }


          console.warn(
            error
          );


          if (
            !hasProduct(
              originalHandle
            )
          ) {

            placeholder.remove();

            continue;
          }


          if (
            placeholder.isConnected
          ) {

            placeholder.replaceWith(
              createUnavailableCard(
                originalHandle
              )
            );
          }
        }
      }
    }


    const workerCount =
      Math.min(
        MAX_CONCURRENT,
        handles.length
      );


    await Promise.all(
      Array.from(
        {
          length:
            workerCount
        },

        () =>
          worker()
      )
    );


    if (
      currentRender !==
      renderToken
    ) {
      return;
    }


    if (loading) {

      loading.hidden =
        true;
    }


    updateEmptyState();


    updateButtons();


    translateAllCards();
  }


  /* =========================================================
     ADD ONE CARD
     ========================================================= */

  async function addCardToPage(
    handle
  ) {
    if (!handle) {
      return;
    }


    const grid =
      document.querySelector(
        '[data-wishlist-grid]'
      );


    if (!grid) {
      return;
    }


    const existing =
      Array.from(
        grid.querySelectorAll(
          '[data-wishlist-storage-handle]'
        )
      )
      .some(
        element =>
          element.dataset
            .wishlistStorageHandle ===
          handle
      );


    if (existing) {
      return;
    }


    const placeholder =
      createPlaceholder(
        handle
      );


    grid.prepend(
      placeholder
    );


    grid.hidden =
      false;


    try {

      const html =
        await fetchCardHTML(
          handle
        );


      if (
        !hasProduct(
          handle
        )
      ) {

        placeholder.remove();

        return;
      }


      const card =
        buildCard(
          handle,
          html
        );


      if (
        placeholder.isConnected
      ) {

        placeholder.replaceWith(
          card
        );
      }

    } catch (error) {

      if (
        error.name !==
        'AbortError'
      ) {

        console.warn(
          error
        );
      }
    }
  }


  /* =========================================================
     CART COUNT

     Native Horizon owns the cart count. No observer, no polling,
     no page-load cart request. These helpers are used only after
     adding an item from the wishlist page itself.
     ========================================================= */

  function renderNativeCartCount(
    count,
    animate = true
  ) {
    const safeCount =
      Math.max(
        0,
        Number(count) || 0
      );

    document
      .querySelectorAll(
        'cart-icon'
      )
      .forEach(
        cartIcon => {
          if (
            typeof cartIcon
              .renderCartBubble ===
            'function'
          ) {
            cartIcon.renderCartBubble(
              safeCount,
              animate
            );
          }
        }
      );
  }


  function incrementNativeCartCount(
    amount = 1
  ) {
    const cartIcon =
      document.querySelector(
        'cart-icon'
      );

    if (!cartIcon) {
      return;
    }

    const current =
      Number(
        cartIcon.currentCartCount
      );

    if (!Number.isFinite(current)) {
      return;
    }

    renderNativeCartCount(
      current +
        (Number(amount) || 0)
    );
  }


  async function verifyNativeCartCount() {
    try {
      const getCart =
        window.Shopify
          ?.actions
          ?.getCart;

      if (typeof getCart !== 'function') {
        return;
      }

      const result =
        await getCart();

      const count =
        Number(
          result?.cart
            ?.totalQuantity
        );

      if (Number.isFinite(count)) {
        renderNativeCartCount(
          count,
          false
        );
      }

    } catch (error) {
      /* Native Horizon remains authoritative. */
    }
  }


  /* =========================================================
     ADD TO CART
     ========================================================= */

  async function addToCart(
    button
  ) {
    const variantId =
      Number(
        button.dataset
          .variantId
      );


    if (!variantId) {
      return;
    }


    /*
     * Päriselt unavailable toodet
     * ei proovita ostukorvi lisada.
     */
    if (
      button.dataset
        .wishlistUnavailable ===
      'true'
    ) {
      return;
    }


    /*
     * Väldi topeltklikki.
     */
    if (
      button.dataset
        .wishlistBusy ===
      'true'
    ) {
      return;
    }


    button.dataset
      .wishlistBusy =
      'true';


    const originalText =
      button.textContent;


    /*
     * See disabled on ainult AJUTINE.
     * See ei tähenda unavailable.
     */
    button.disabled =
      true;


    button.textContent =
      t(
        'adding'
      );


    try {

      const response =
        await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/add.js`,
          {
            method:
              'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      variantId,

                    quantity:
                      1
                  }
                ]
              })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Cart add failed'
        );
      }


      button.textContent =
        t(
          'added'
        );


      button.classList.add(
        'wishlist-add-cart--added'
      );


      incrementNativeCartCount(1);


      verifyNativeCartCount();


      window.setTimeout(
        () => {

          /*
           * Kõigepealt busy false.
           */
          button.dataset
            .wishlistBusy =
            'false';


          /*
           * See toode oli algselt saadaval,
           * seega nupp läheb jälle aktiivseks.
           */
          button.disabled =
            false;


          button.textContent =
            t(
              'addToCart'
            );


          button.classList.remove(
            'wishlist-add-cart--added'
          );
        },

        1300
      );

    } catch (error) {

      console.warn(
        error
      );


      button.textContent =
        t(
          'tryAgain'
        );


      button.classList.add(
        'wishlist-add-cart--error'
      );


      window.setTimeout(
        () => {

          button.dataset
            .wishlistBusy =
            'false';


          button.disabled =
            false;


          button.textContent =
            t(
              'addToCart'
            );


          button.classList.remove(
            'wishlist-add-cart--error'
          );
        },

        1700
      );
    }
  }


  /* =========================================================
     CLICK HANDLER
     ========================================================= */

  document.addEventListener(
    'click',

    event => {

      if (
        !(
          event.target
          instanceof Element
        )
      ) {
        return;
      }


      /* REMOVE */

      const removeButton =
        event.target.closest(
          '[data-wishlist-remove]'
        );


      if (removeButton) {

        event.preventDefault();


        event.stopImmediatePropagation();


        const clickedCard =
          removeButton.closest(
            '[data-wishlist-card-fragment], .wishlist-unavailable-card'
          );


        const originalHandle =
          clickedCard
            ?.dataset
            ?.wishlistStorageHandle ||

          clickedCard
            ?.dataset
            ?.productHandle ||

          removeButton
            .dataset
            .wishlistStorageHandle ||

          removeButton
            .dataset
            .wishlistRemove ||

          removeButton
            .dataset
            .productHandle;


        if (!originalHandle) {
          return;
        }


        const removed =
          removeProduct(
            originalHandle
          );


        if (removed) {

          if (clickedCard) {

            clickedCard.remove();
          }


          removeCardFromPage(
            originalHandle
          );
        }


        return;
      }


      /* ADD TO CART */

      const cartButton =
        event.target.closest(
          '[data-wishlist-add-to-cart]'
        );


      if (cartButton) {

        event.preventDefault();


        event.stopImmediatePropagation();


        addToCart(
          cartButton
        );


        return;
      }


      /* HEART */

      const heartButton =
        event.target.closest(
          '[data-wishlist-button]'
        );


      if (heartButton) {

        event.preventDefault();


        event.stopImmediatePropagation();


        const handle =
          heartButton.dataset
            .productHandle;


        if (handle) {

          toggleProduct(
            handle
          );
        }


        return;
      }


      /* PRODUCT CARD CLICK */

      const productCard =
        event.target.closest(
          '.wishlist-page product-card'
        );


      if (!productCard) {
        return;
      }


      if (
        event.target.closest(
          'a, button, input, select, textarea, [role="button"]'
        )
      ) {
        return;
      }


      const overlayLink =
        productCard.querySelector(
          ':scope > .product-card__link'
        );


      if (
        overlayLink &&
        overlayLink.href
      ) {

        window.location.href =
          overlayLink.href;
      }
    },

    true
  );


  /* =========================================================
     WISHLIST CHANGE
     ========================================================= */

  document.addEventListener(
    'wishlist:change',

    event => {

      updateButtons();


      const action =
        event.detail
          ?.action;


      const handle =
        event.detail
          ?.handle;


      if (
        action ===
        'remove'
      ) {

        removeCardFromPage(
          handle
        );


        return;
      }


      if (
        action ===
        'add'
      ) {

        addCardToPage(
          handle
        );
      }
    }
  );


  /* =========================================================
     LANGUAGE WATCHER
     ========================================================= */

  function watchLanguageChanges() {

    /*
     * PERFORMANCE FIX:
     * Vana versioon jälgis MutationObserveriga KOGU #header-group DOM-i
     * (subtree + attributes + characterData). See reageeris ka sticky
     * headeri, cart badge'i ja wishlist count'i muudatustele ning võis
     * tekitada mobiilis pideva 150 ms uuendustsükli.
     *
     * Keelevahetuse jaoks piisab locale input/select change-eventist.
     * Shopify tavapärane locale vahetus teeb niikuinii navigatsiooni,
     * kuid see listener katab ära ka dünaamilise variandi.
     */
    if (
      window.__OSTUKLIKK_WISHLIST_LANGUAGE_WATCH__
    ) {
      return;
    }


    window.__OSTUKLIKK_WISHLIST_LANGUAGE_WATCH__ =
      true;


    document.addEventListener(
      'change',

      event => {

        const target =
          event.target;


        if (
          !(target instanceof Element)
        ) {
          return;
        }


        if (
          !target.matches(
            'select[name="locale_code"], input[name="locale_code"]'
          )
        ) {
          return;
        }


        if (
          languageUpdateTimer
        ) {

          window.clearTimeout(
            languageUpdateTimer
          );
        }


        languageUpdateTimer =
          window.setTimeout(
            () => {

              updateButtons();


              translateAllCards();

            },

            0
          );
      }
    );
  }


  /* =========================================================
     SHOPIFY EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',

    () => {

      updateButtons();


      loadWishlistPage();
    }
  );


  /* =========================================================
     INIT
     ========================================================= */

  function init() {

    updateButtons();


    initProductWishlistLayerFix();


    loadWishlistPage();


    watchLanguageChanges();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once:
          true
      }
    );

  } else {

    init();
  }


  /* =========================================================
     PUBLIC API
     ========================================================= */

  window.ShopWishlist = {
    get:
      getWishlist,

    add:
      addProduct,

    remove:
      removeProduct,

    toggle:
      toggleProduct,

    has:
      hasProduct
  };
})();